(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["balcour-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bch-sticky')) {
    class BchSticky extends HTMLElement {
      constructor() { super(); }
      connectedCallback() {
        this.alwaysSticky = this.getAttribute('data-sticky-type') === 'always';
        this.lastY = window.pageYOffset || 0;
        this.tickQueued = false;
        this.bound = this.onScroll.bind(this);
        // Initial state
        if (this.alwaysSticky) this.classList.add('bch-sticky-on');
        window.addEventListener('scroll', this.bound, { passive: true });
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.bound);
      }
      onScroll() {
        if (this.tickQueued) return;
        this.tickQueued = true;
        requestAnimationFrame(() => {
          this.tickQueued = false;
          var y = window.pageYOffset || 0;
          if (y > 8) this.classList.add('is-stuck');
          else this.classList.remove('is-stuck');
          this.lastY = y;
        });
      }
    }
    customElements.define('bch-sticky', BchSticky);
  }

  } catch(e) { console.error(e); }
})();
})();
